import type { ReactNode } from 'react';
import { ProviderContext, ProviderContextType } from '../../context/ProviderContext';

export function ProviderProvider({
  children,
  ...value
}: {
  children: ReactNode;
} & ProviderContextType) {
  return <ProviderContext.Provider value={value}>{children}</ProviderContext.Provider>;
}
